export const USER_SUMMARY_RECEIVED = 'USER_SUMMARY_RECEIVED'
export const USER_SUMMARY_UPDATED = 'USER_SUMMARY_UPDATED'
export const USER_SUMMARY_UNLOADED = 'USER_SUMMARY_UNLOADED'
